@if (error) {
  <mbs-alert
    class="mb-4"
    [icon]="true"
    [type]="MbsPopupType.danger">
    {{ error }}
  </mbs-alert>
}

<div class="row">
  @for (storage of storages; track storage; let index = $index) {
    <div class="col-4">
      <button
        [attr.data-e2e]="e2eLocators.storageBtn + '-' + storage.type"
        [class.-selected]="storage.type === wizardForm.value?.storageType"
        [class]="'add-storage-account-wizard_tile mb-3'"
        (click)="wizardForm.get('storageType').patchValue(storage.type)">
        <div class="d-flex align-items-center flex-column w-100 h-100 p-3">
          <span class="mb-2 mbs-storage mbs-storage_{{ storage.type | storageIcon }} add-storage-account-wizard_storage-icon-size"></span>
          <span>{{ storage.type | storageDisplayName }}</span>
          @if (storage.count) {
            <span class="text-muted small mt-1">
              {{ 'storages:addStorageAccountWizard.selectStorageStep.storageAccountsCount' | i18next: { count: storage.count } }}
            </span>
          }
        </div>
      </button>
    </div>
  }
</div>
